/**
 * @generated SignedSource<<66bbabd2227cd43e0ef101ef9354bd52>>
 * @relayHash e476390ffa12b3e505bd7e8ac519e061
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21f4290cdcdb12ab3f1c90bcbc8c6b47b7fbcce98706579b8ee723ba26cca755

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type BlockedAccessSubjectType = "GROUP" | "USER" | "%future added value";
export type ResourceAccessType = "EDIT" | "VIEW" | "%future added value";
export type BlockedAccessSubjectInput = {
  subjectId: string;
  subjectType: BlockedAccessSubjectType;
};
export type useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation$variables = {
  accessType: ResourceAccessType;
  contentId: AGG$Long;
  spaceRoleId?: string | null | undefined;
  subjects: ReadonlyArray<BlockedAccessSubjectInput | null | undefined>;
};
export type useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation$data = {
  readonly resolveRestrictionsForSubjects: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation = {
  response: useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation$data;
  variables: useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accessType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceRoleId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subjects"
},
v4 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "accessType",
            "variableName": "accessType"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "spaceRoleId",
            "variableName": "spaceRoleId"
          },
          {
            "kind": "Variable",
            "name": "subjects",
            "variableName": "subjects"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ResolveRestrictionsPayload",
    "kind": "LinkedField",
    "name": "resolveRestrictionsForSubjects",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "e476390ffa12b3e505bd7e8ac519e061",
    "id": "21f4290cdcdb12ab3f1c90bcbc8c6b47b7fbcce98706579b8ee723ba26cca755",
    "metadata": {},
    "name": "useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation",
    "operationKind": "mutation",
    "text": "mutation useRealtimeAccessRequestsFlagsResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!,$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType,contentId:$contentId,subjects:$subjects,spaceRoleId:$spaceRoleId}){success,errors{message}}}"
  }
};
})();

(node as any).hash = "20811ee88362a051210b331b739d34c1";

export default node;
